import financing from '../financing';
(globalThis as any).financing = financing;

import FinancingTable from '../components/Financing/Table.svelte';

export default new FinancingTable({
    target: $('#paypal-financing-popup section')[0],
    props: {
        MONTHS: [3, 6, 12, 24],
    },
});
